import { Button, Table } from '@abb/common-ux';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { IServerWithServices, IServiceInstance } from '../../../models';
import { default as ServerWithServicesTableContainer } from './MachineTableContainer';

/* tslint:disable:jsx-no-lambda jsx-no-multiline-js*/
export class ServerWithServicesList extends React.Component<any, any> {
    render() {
        return this.props.server.map((serverWithServices: any, index: number) => {
            return (
                <ServerWithServicesTableContainer key={index.toString()}
                    name={serverWithServices.description.value}
                    serviceInstances={serverWithServices.serviceAllocations}
                    serverWithServicesId={serverWithServices.id}
                    siteId={serverWithServices.siteId}
                />
            );
        });
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ServerWithServicesList) as any);

export function mapStateToProps(store: any) {
  const props = { ...store.servicesState, ...store.serviceOptionsState, ...store.serverState };
  return props;
}

function mapDispatchToProps(dispatch: any) {
  return {};
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./src/modules/license/components/SiteLicense/Machines/MachineList.tsx